// -- External libraries
import { splitProps } from 'solid-js'

import { useImageAtomComponentController } from './image-atom-component-controller.js'
import './image-atom-component.scss'

export default function ImageAtomComponent (props) {
    const {
        mergedProps,
    } = useImageAtomComponentController(props)
    // TODO: We aren't treating placeholder as required, should update this to optional attribute
    const requiredAttributes = [
        'src', 'alt', 'placeholder',
    ]
    const [
        requestAttributes,
        styles,
        attributes,
    ] = splitProps(mergedProps, requiredAttributes, ['class'])

    const rootClasses = ['image-atom-component']
    if (styles.class) rootClasses.push(styles.class)

    // TODO: Can add a generic fallback placeholder image if placeholder is not provided?
    const handleError = (e) => {
        const img = e.currentTarget
        // IMPORTANT: Remove the error handler from this image to prevent infinite loop if placeholder fails
        img.onerror = null

        // Set the placeholder image if it exists and is not the same as the current image
        if (requestAttributes.placeholder && img.src !== requestAttributes.placeholder) {
            // TODO: IF PLACEHOLDER DOESN'T EXIST IT ALSO INFINITE LOOPS
            img.src = requestAttributes.placeholder
        }
    }

    return (
        <img
            class={rootClasses.join(' ')}
            src={requestAttributes.src}
            alt={requestAttributes.alt}
            {...attributes}
            onError={handleError}
        />
    )
}
